import {
    ForumCategoriesFetchFailureAction,
    ForumCategoriesFetchRequestAction,
    ForumCategoriesFetchSuccessAction,
    FORUM_CATEGORIES_FETCH_FAILURE,
    FORUM_CATEGORIES_FETCH_REQUEST,
    FORUM_CATEGORIES_FETCH_SUCCESS,
} from 'mk2/apps/forum/containers/ForumCategories/ForumCategories.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface ForumCategoriesPageState {
    categoryIds: number[];
    activeDaysWithTopicId: number | null;
    testingsTopicId: number | null;
    contestsTopicId: number | null;
    counsellingCategoryId: number | null;
    followingTopicIds: number[];
    numTopicsInCategory: {[categoryId: number]: number};
    numGroupsInCategory: {[categoryId: number]: number};

    loadingState: LoadingState;
    errorMessage: string;
}

export const initiatialForumCategoriesPageState: ForumCategoriesPageState = {
    categoryIds: [],
    activeDaysWithTopicId: null,
    testingsTopicId: null,
    contestsTopicId: null,
    counsellingCategoryId: null,
    followingTopicIds: [],
    numTopicsInCategory: {},
    numGroupsInCategory: {},

    loadingState: LoadingState.INIT,
    errorMessage: null,
};

declare type ForumCategoriesPageAction =
    ForumCategoriesFetchRequestAction
    | ForumCategoriesFetchSuccessAction
    | ForumCategoriesFetchFailureAction;

const forumCategoriesPageReducer: Reducer<ForumCategoriesPageState> =
    (state = initiatialForumCategoriesPageState, action: ForumCategoriesPageAction) => {

    switch (action.type) {
        case FORUM_CATEGORIES_FETCH_REQUEST:
        case FORUM_CATEGORIES_FETCH_FAILURE: {
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        case FORUM_CATEGORIES_FETCH_SUCCESS:
            return {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
                categoryIds: action.response.result.categories,
                activeDaysWithTopicId: action.response.result.activeDaysWithTopic,
                testingsTopicId: action.response.result.testingsTopic,
                contestsTopicId: action.response.result.contestsTopic,
                counsellingCategoryId: action.response.result.counsellingCategory,
                followingTopicIds: action.response.result.followingTopics,
                numTopicsInCategory: action.response.result.numTopicsInCategory,
                numGroupsInCategory: action.response.result.numGroupsInCategory,
            };

        default:
            return state;
    }
};

export default forumCategoriesPageReducer;
